import {
  blue,
  cyan,
  geekblue,
  gold,
  green,
  lime,
  magenta,
  orange,
  purple,
  red,
  volcano,
  yellow,
} from '@ant-design/colors';
import { type ColorPickerProps } from 'antd/es';

type Preset = Required<ColorPickerProps>['presets'][number];

// Indici della palette Ant Design (0–9) da cui estrarre i colori predefiniti.
// Gli indici 2–7 escludono le tinte troppo chiare (0–1) e i toni troppo scuri (8–9).
const PALETTE_FROM = 1;
const PALETTE_TO = 6;
const STEPS = 8;

function parseHex(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  return [
    Number.parseInt(h.slice(0, 2), 16),
    Number.parseInt(h.slice(2, 4), 16),
    Number.parseInt(h.slice(4, 6), 16),
  ];
}

function toHex(r: number, g: number, b: number): string {
  return `#${[r, g, b]
    .map(v => Math.round(v).toString(16).padStart(2, '0'))
    .join('')}`;
}

function interpolate(colors: string[]): string[] {
  const palette = colors.slice(PALETTE_FROM, PALETTE_TO + 1);
  const start = parseHex(palette[0]);
  const end = parseHex(palette[palette.length - 1]);

  return Array.from({ length: STEPS }, (_, i) => {
    const t = i / (STEPS - 1);
    return toHex(
      start[0] + (end[0] - start[0]) * t,
      start[1] + (end[1] - start[1]) * t,
      start[2] + (end[2] - start[2]) * t,
    );
  });
}

export const colorPickerPresets: Preset[] = [
  {
    label: 'Colori Predefiniti',
    colors: [
      ...interpolate(red),
      ...interpolate(volcano),
      ...interpolate(orange),
      ...interpolate(gold),
      ...interpolate(yellow),
      ...interpolate(lime),
      ...interpolate(green),
      ...interpolate(cyan),
      ...interpolate(blue),
      ...interpolate(geekblue),
      ...interpolate(purple),
      ...interpolate(magenta),
    ],
  },
];
